<template>
  <div v-if="scripts.length === 0" class="data-off">
    <div class="v-img">
      <img :src="getAssetImageUrl('app/status/no-data.svg')" alt="" />
    </div>
    <p>{{ t('download_no_history') }}</p>
  </div>
  <ChatScriptDownloadTable v-else-if="isDesktopOrTablet" :scripts="scripts" @update="updateScript" />
  <ChatScriptDownloadList v-else :scripts="scripts" @update="updateScript" />
</template>

<script setup lang="ts">
import ChatScriptDownloadList from '@/components/domains/chat/script-download/ChatScriptDownloadList.vue';
import ChatScriptDownloadTable from '@/components/domains/chat/script-download/ChatScriptDownloadTable.vue';
import { useDeviceSize } from '@/composables/shared/useDeviceSize';
import { ChatScript } from '@/types/response';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

withDefaults(
  defineProps<{
    scripts: ChatScript[];
  }>(),
  {
    scripts: () => [],
  }
);

const emit = defineEmits<{ update: [chatId: string, updatedScript: Partial<ChatScript>] }>();

const { t } = useI18n();
const { isDesktopOrTablet } = useDeviceSize();

const updateScript = (chatId: string, updatedScript: Partial<ChatScript>) => {
  emit('update', chatId, updatedScript);
};
</script>

<style scoped lang="scss">
.data-off {
  height: 100%;
  text-align: center;
  padding: 8rem 0;
  .v-img {
    margin-bottom: 1rem;
  }
}
</style>
